import { WarehouseAddressCollectionDataProvider } from '@steelbuy/data-provider';
import { CheckoutChooseAddress } from '../../../components/checkout/CheckoutChooseAddress';

export const MyAlertsCheckoutChooseAddressView = () => (
    <WarehouseAddressCollectionDataProvider>
        <CheckoutChooseAddress />
    </WarehouseAddressCollectionDataProvider>
);
